import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/components/log-time-line.vue'
wx.createComponent(Component)